@if (treeData.length === 0) {
<div class="bg-white rounded-lg shadow-sm border border-gray-100 p-8 mb-4">
    <div class="empty-state">
        <i nz-icon nzType="folder" nzTheme="outline" class="empty-icon"></i>
        <h3 class="empty-text">No location groups have been created yet</h3>
        <button nz-button nzType="primary" type="button" (click)="addGroupHandler()" class="rounded-md">
            <i nz-icon nzType="plus" class="mr-1"></i>Add First Group
        </button>
    </div>
</div>
}
<nz-modal nzCentered [(nzVisible)]="isSelectionPopup" nzTitle="What would you like to do?" [nzMaskClosable]="false"
    (nzOnCancel)="isSelectionPopup = false" [nzFooter]="null" nzOkText="Save" nzWidth="400px">
    <ng-container *nzModalContent>
        <div class="flex items-center justify-center gap-2">
            <button nz-button nzType="default" type="button" (click)="addGroupHandler()"
                [disabled]="selectedNode && hasLocations(selectedNode)" nz-tooltip
                [nzTooltipTitle]="selectedNode && hasLocations(selectedNode) ? 'Cannot add groups to a group that contains locations' : ''"
                nzTooltipColor="#fff">
                Add Group
            </button>
            <button nz-button nzType="primary" type="button" (click)="addLocationHandler()">Add Location</button>
        </div>
    </ng-container>
</nz-modal>

<nz-modal nzCentered [(nzVisible)]="isGroupModal" [nzTitle]="((modalType | titlecase) || 'Add Group' )"
    (nzOnCancel)="isGroupModal = false" (nzOnOk)="saveGroup()" nzOkText="Save" nzWidth="400px">
    <ng-container *nzModalContent>
        <form nz-form [nzLayout]="'vertical'" [formGroup]="groupForm" role="form" aria-labelledby="groupFormLabel">
            <nz-form-item>
                <nz-form-label nzFor="group_name" nzRequired>Group Name</nz-form-label>
                <nz-form-control [nzErrorTip]="groupName">
                    <input nz-input formControlName="group_name" placeholder="Type group name" aria-required="true" />
                </nz-form-control>
                <ng-template #groupName let-control>
                    <span *ngIf="control.errors?.['required']" class="error-message">Required!</span>
                </ng-template>
            </nz-form-item>
        </form>
    </ng-container>
</nz-modal>

<nz-modal nzCentered [(nzVisible)]="isMoveModal" [nzTitle]="'Move ' + (moveType === 'location' ? 'Location' : 'Group')"
    (nzOnCancel)="isMoveModal = false" (nzOnOk)="confirmMove()" nzOkText="Move" nzWidth="450px">
    <ng-container *nzModalContent>
        <div class="mb-4">
            <p class="text-gray-600 mb-2">
                Select the target {{ moveType === 'location' ? 'group' : 'parent group' }} for
                <strong>{{ selectedNode?.title }}</strong>
            </p>
        </div>
        <nz-form-item>
            <nz-form-label>Target Group</nz-form-label>
            <nz-form-control>
                <nz-select [(ngModel)]="selectedTargetGroupId" nzPlaceHolder="Select target group" nzShowSearch
                    nzAllowClear class="w-full">
                    <nz-option *ngFor="let group of availableGroups" [nzValue]="group.id" [nzLabel]="group.name">
                    </nz-option>
                </nz-select>
            </nz-form-control>
        </nz-form-item>
    </ng-container>
</nz-modal>

<nz-modal nzCentered [(nzVisible)]="isLocationModal" [nzTitle]="(modalType | titlecase) + ' Location'"
    (nzOnCancel)="isLocationModal = false" nzNoAnimation [nzOkText]="modalType !== 'view' ? 'Save' : null"
    [nzCancelText]="modalType !== 'view' ? 'Cancel' : null" nzWidth="900px" (nzOnOk)="saveLocation()">
    <ng-container *nzModalContent>
        <form nz-form [nzLayout]="modalType !== 'view' ? 'vertical': 'horizontal'" [formGroup]="locationForm"
            role="form" aria-labelledby="locationFormLabel">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 24 }">
                <div nz-col class="gutter-row" [nzSpan]="12">
                    <nz-form-item>
                        <nz-form-label nzFor="registered_name" nzRequired>Registered Name</nz-form-label>
                        <nz-form-control [nzErrorTip]="regName">
                            <input nz-input formControlName="registered_name" placeholder="Type registered name"
                                aria-required="true" />
                        </nz-form-control>
                        <ng-template #regName let-control>
                            <span *ngIf="control.errors?.['required']" class="error-message">Required!</span>
                        </ng-template>
                    </nz-form-item>
                </div>
                <div nz-col class="gutter-row" [nzSpan]="12">
                    <nz-form-item>
                        <nz-form-label nzFor="display_name" nzRequired>Location Name</nz-form-label>
                        <nz-form-control [nzErrorTip]="locationName">
                            <input nz-input formControlName="display_name" placeholder="Type location name"
                                aria-required="true" />
                        </nz-form-control>
                        <ng-template #locationName let-control>
                            <span *ngIf="control.errors?.['required']" class="error-message">Required!</span>
                        </ng-template>
                    </nz-form-item>
                </div>
                <div nz-col class="gutter-row" [nzXs]="24" [nzSm]="24" [nzMd]="12" [nzLg]="12">
                    <nz-form-item>
                        <nz-form-label nzFor="registered_address" nzRequired>Registered Address</nz-form-label>
                        <nz-form-control [nzErrorTip]="regAdd">
                            <app-address-input-google
                                [initialValue]="locationForm.get('registered_address')?.value"
                                (addressSelected)="onAddressChange($event)">
                            </app-address-input-google>
                        </nz-form-control>
                        <ng-template #regAdd let-control>
                            <span *ngIf="control.errors?.['required']" class="error-message">Required!</span>
                        </ng-template>
                    </nz-form-item>
                </div>
            </div>
            <nz-divider nzOrientation="left" nzText="Location Personnel details"></nz-divider>
            <nz-table #basicTable [nzScroll]="{ y:'250px', x: '820px' }" [nzShowPagination]="false"
                [nzData]="spocDetail.getRawValue()" [nzBordered]="false">
                <thead>
                    <tr>
                        <th><small class="text-red-500 mr-1">*</small>Designation</th>
                        <th><small class="text-red-500 mr-1">*</small>Name</th>
                        <th><small class="text-red-500 mr-1">*</small>Email</th>
                        <th><small class="text-red-500 mr-1">*</small>Contact</th>
                        <th nzWidth="100px" *ngIf="modalType !== 'view'">Actions</th>
                    </tr>
                </thead>
                <tbody formArrayName="spoc_detail">
                    <ng-container *ngFor="let spoc of spocDetail.controls; let i = index" [formGroupName]="i"
                        class="border rounded-md p-2 mb-4">
                        <tr>
                            <td>
                                <nz-form-item *ngIf="modalType !== 'view'">
                                    <nz-form-control [nzErrorTip]="designationErr">
                                        <input nz-input formControlName="designation" placeholder="Type designation" />
                                    </nz-form-control>
                                    <ng-template #designationErr let-control>
                                        @if (control.errors?.['required']) { Required! }
                                    </ng-template>
                                </nz-form-item>
                                <input *ngIf="modalType === 'view'" nz-input formControlName="designation"
                                    placeholder="Type designation" />
                            </td>
                            <td>
                                <nz-form-item *ngIf="modalType !== 'view'">
                                    <nz-form-control [nzErrorTip]="nameErr">
                                        <input nz-input formControlName="name" placeholder="Type name" />
                                    </nz-form-control>
                                    <ng-template #nameErr let-control>
                                        @if (control.errors?.['required']) { Required! }
                                    </ng-template>
                                </nz-form-item>
                                <input *ngIf="modalType === 'view'" nz-input formControlName="name"
                                    placeholder="Type name" />
                            </td>
                            <td>
                                <nz-form-item *ngIf="modalType !== 'view'">
                                    <nz-form-control [nzErrorTip]="emailErr">
                                        <input nz-input formControlName="email" type="email" placeholder="Type email" />
                                    </nz-form-control>
                                    <ng-template #emailErr let-control>
                                        @if (control.errors?.['required']) { Required! }
                                        @if (control.errors?.['strictEmail']) { Email must be like abc&#64;gmail.com }
                                    </ng-template>
                                </nz-form-item>
                                <input *ngIf="modalType === 'view'" nz-input formControlName="email"
                                    placeholder="Type email" />
                            </td>
                            <td>
                                <nz-form-item *ngIf="modalType !== 'view'">
                                    <nz-form-control [nzErrorTip]="contactErr">
                                        <input nz-input formControlName="contact" maxlength="10" minlength="10" OnlyNumber
                                            inputmode="numeric" pattern="[0-9]*"
                                            placeholder="Type contact" />
                                    </nz-form-control>
                                    <ng-template #contactErr let-control>
                                        @if (control.errors?.['required']) { Required! }
                                        @if (control.errors?.['pattern']) { Enter exactly 10 digits! }
                                    </ng-template>
                                </nz-form-item>
                                <input *ngIf="modalType === 'view'" nz-input formControlName="contact"
                                    placeholder="Type contact" />
                            </td> 
                            <td *ngIf="modalType !== 'view'">
                                <div class="flex gap-2 mb-6">
                                    <button nz-button nzType="default" nzShape="circle" (click)="addNewSpoc()"
                                        class="border-0">
                                        <i nz-icon nzType="plus" nzTheme="outline"></i>
                                    </button>
                                    <button *ngIf="i !== 0" nz-button nzType="default" nzShape="circle" class="border-0"
                                        nzDanger (click)="deleteLocationSpoc(i)">
                                        <i nz-icon nzType="delete" nzTheme="outline"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </nz-table>
        </form>
    </ng-container>
</nz-modal>

<!-- Enhanced tree view container with shadow and border -->
<div class="bg-white rounded-lg shadow-sm border border-gray-100 p-4 mb-4">
    <!-- Tree header with title -->
    <div class="flex items-center justify-between mb-4 border-b pb-2">
        <h3 class="text-base font-medium text-gray-700">Location Groups</h3>
    </div>

    <div class="max-h-[65dvh] overflow-y-auto tree-container">
        @if (treeData.length === 0) {
        <div class="empty-state py-8">
            <i nz-icon nzType="folder-open" nzTheme="outline" class="empty-icon text-gray-300"></i>
            <h3 class="empty-text">No location data available</h3>
        </div>
        } @else {
        <nz-tree-view [nzTreeControl]="treeControl" [nzDataSource]="dataSource" [trackBy]="trackBy">
            <nz-tree-node *nzTreeNodeDef="let node" nzTreeNodeIndentLine>
                <nz-tree-node-option (nzClick)="nodeClick(node, 'view')" class="node-item">
                    <div class="flex items-center">
                        <i nz-icon nzType="environment" nzTheme="outline" class="text-blue-500"></i>
                        <span class="ml-1">
                          <span *ngIf="getLocationId(node) != null" class="text-gray-500 mr-1">({{ getLocationId(node) }})</span>
                          {{ node.title }}
                        </span>
                    </div>
                </nz-tree-node-option>
                <div class="node-actions">
                    <button nz-button nzType="text" nzSize="small" (click)="nodeClick(node, 'edit')" class="action-btn"
                        nz-tooltip nzTooltipTitle="Edit" nzTooltipColor="#fff">
                        <i nz-icon nzType="edit" nzTheme="outline" class="text-blue-500"></i>
                    </button>
                    <button nz-button nzType="text" nzSize="small" (click)="openMoveModal(node, 'location')"
                        class="action-btn" nz-tooltip nzTooltipTitle="Move to Group" nzTooltipColor="#fff">
                        <i nz-icon nzType="drag" nzTheme="outline" class="text-purple-500"></i>
                    </button>
                    <button nz-button nzType="text" nzSize="small" nz-popconfirm
                        nzPopconfirmTitle="Are you sure you want to delete this location ?"
                        nzPopconfirmPlacement="bottom" (nzOnConfirm)="deleteNode(node)" class="action-btn" nz-tooltip
                        nzTooltipTitle="Delete" nzTooltipColor="#fff">
                        <i nz-icon nzType="delete" nzTheme="outline" class="text-red-500"></i>
                    </button>
                </div>
            </nz-tree-node>
            <nz-tree-node *nzTreeNodeDef="let node; when: hasChild" nzTreeNodeIndentLine>
                <nz-tree-node-toggle class="toggle-icon">
                    <i nz-icon nzType="caret-down" nzTreeNodeToggleRotateIcon></i>
                </nz-tree-node-toggle>
                <nz-tree-node-option [nzDisabled]="node.disabled" [nzSelected]="selectListSelection.isSelected(node)"
                    class="node-item">
                    <div class="flex items-center">
                        <i nz-icon nzType="folder" nzTheme="fill" class="text-yellow-500"></i>
                        <span class="ml-1 font-medium">{{ node.title }}</span>
                    </div>
                </nz-tree-node-option>
                <div class="node-actions">
                    <button nz-button nzType="text" nzSize="small" (click)="nodeClick(node, 'add')" class="action-btn"
                        nz-tooltip
                        [nzTooltipTitle]="hasLocations(node) ? 'Add Location (Groups with locations cannot have sub-groups)' : 'Add Group or Location'"
                        nzTooltipColor="#fff">
                        <i nz-icon nzType="plus" nzTheme="outline" class="text-green-500"></i>
                    </button>
                    <button nz-button nzType="text" nzSize="small" (click)="nodeClick(node, 'edit')" class="action-btn"
                        nz-tooltip nzTooltipTitle="Edit Group" nzTooltipColor="#fff">
                        <i nz-icon nzType="edit" nzTheme="outline" class="text-blue-500"></i>
                    </button>
                    <button *ngIf="node.level !== 0" nz-button nzType="text" nzSize="small"
                        (click)="openMoveModal(node, 'group')" class="action-btn" nz-tooltip nzTooltipTitle="Move Group"
                        nzTooltipColor="#fff">
                        <i nz-icon nzType="drag" nzTheme="outline" class="text-purple-500"></i>
                    </button>
                    <button *ngIf="node.level !== 0" nz-button nzType="text" nzSize="small" nz-popconfirm
                        nzPopconfirmTitle="Are you sure you want to delete this group ?"
                        nzPopconfirmPlacement="bottomRight" (nzOnConfirm)="deleteNode(node)" class="action-btn"
                        nz-tooltip nzTooltipTitle="Delete" nzTooltipColor="#fff">
                        <i nz-icon nzType="delete" nzTheme="outline" class="text-red-500"></i>
                    </button>
                </div>
            </nz-tree-node>
        </nz-tree-view>
        }
    </div>
</div>

<nz-divider></nz-divider>
<div class="flex justify-end">
    <button [disabled]="!isGroupDirty" nz-button nz-popconfirm
        nzPopconfirmTitle="Are you sure you want to submit group ?" nzPopconfirmPlacement="bottom"
        (nzOnConfirm)="submit()" nzType="primary" class="rounded-full px-6 flex items-center">
        <i nz-icon nzType="save" nzTheme="outline" class="mr-1"></i>
        Submit Changes
    </button>
</div>